module.exports = __webpack_public_path__ + "static/img/natasha_profile_800x625.82b74d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/natasha_profile_800x625.jpg
// module id = +j0q
// module chunks = 0